export const orderlist = [
  {
    name: "Cristy Brandt",
    email: "cbrandt0@google.com.hk",
    address: "9265 Portage Center",
    phone: "735-257-5821",
    session: "fdc82fde-2984-4e68-a331-345fd5f05687",
    cart: [
      { id: 731, name: "Juice - Apple Cider", quantity: 47, price: 717.09 },
    ],
    totalCost: 536.32,
    orderID: 469447732,
    orderStatus: "in progress",
    waitingTime: 17,
    ordertime: "2023-03-05T20:54:15Z",
    completetime: "2023-02-19T03:38:56Z",
  },
  {
    name: "Rhonda Attwoul",
    email: "rattwoul1@ucoz.ru",
    address: "904 Burrows Hill",
    phone: "973-540-7245",
    session: "970a862d-afb4-43a5-b6ef-9a29680ed5ce",
    cart: [
      { id: 902, name: "Flower - Daisies", quantity: 6, price: 851.38 },
      {
        id: 623,
        name: "Water - Mineral, Carbonated",
        quantity: 55,
        price: 687.8,
      },
      { id: 446, name: "Broom Handle", quantity: 67, price: 812.7 },
      {
        id: 16,
        name: "Soup Knorr Chili With Beans",
        quantity: 87,
        price: 29.77,
      },
    ],
    totalCost: 976.35,
    orderID: 763789935,
    orderStatus: "in progress",
    waitingTime: 89,
    ordertime: "2022-05-22T15:28:04Z",
    completetime: "2022-06-28T13:04:20Z",
  },
  {
    name: "Alameda Ellard",
    email: "aellard2@bloglines.com",
    address: "6 Amoth Circle",
    phone: "715-631-7036",
    session: "2e690778-a3e1-4591-82d0-6ef7755ccec5",
    cart: [
      {
        id: 146,
        name: "Wine - Fino Tio Pepe Gonzalez",
        quantity: 59,
        price: 810.49,
      },
      { id: 128, name: "Jameson - Irish Whiskey", quantity: 95, price: 415.2 },
      { id: 62, name: "Snapple Lemon Tea", quantity: 91, price: 878.53 },
      { id: 515, name: "Rye Special Old", quantity: 27, price: 52.76 },
      { id: 954, name: "Cabbage - Savoy", quantity: 58, price: 378.01 },
      { id: 887, name: "Tomatoes - Roma", quantity: 61, price: 493.44 },
      { id: 459, name: "Pork - Kidney", quantity: 29, price: 165.99 },
      {
        id: 224,
        name: "Sauce - Fish 25 Ozf Bottle",
        quantity: 71,
        price: 331.67,
      },
      {
        id: 965,
        name: "Bread - 10 Grain Parisian",
        quantity: 37,
        price: 86.42,
      },
      { id: 747, name: "Capers - Ox Eye Daisy", quantity: 30, price: 989.05 },
    ],
    totalCost: 948.41,
    orderID: 992720806,
    orderStatus: "pending",
    waitingTime: 15,
    ordertime: "2023-03-29T06:09:18Z",
    completetime: "2023-02-07T10:45:15Z",
  },
  {
    name: "Denice Walczynski",
    email: "dwalczynski3@hatena.ne.jp",
    address: "1688 Thompson Plaza",
    phone: "500-591-7193",
    session: "9e02d80b-563a-4e51-9684-53d06dac38f4",
    cart: [
      {
        id: 885,
        name: "Table Cloth 144x90 White",
        quantity: 85,
        price: 425.91,
      },
      {
        id: 943,
        name: "Sping Loaded Cup Dispenser",
        quantity: 66,
        price: 883.45,
      },
      {
        id: 439,
        name: "Chocolate Bar - Smarties",
        quantity: 82,
        price: 847.05,
      },
      {
        id: 246,
        name: "Ice Cream Bar - Hagen Daz",
        quantity: 50,
        price: 722.37,
      },
      { id: 950, name: "Squid - U - 10 Thailand", quantity: 43, price: 133.95 },
      { id: 894, name: "Peach - Halves", quantity: 79, price: 698.06 },
      {
        id: 17,
        name: "Sugar - Sweet N Low, Individual",
        quantity: 86,
        price: 477.63,
      },
      {
        id: 724,
        name: "Pepper - Chillies, Crushed",
        quantity: 33,
        price: 923.27,
      },
      {
        id: 89,
        name: "Irish Cream - Butterscotch",
        quantity: 53,
        price: 271.07,
      },
    ],
    totalCost: 361.36,
    orderID: 759214628,
    orderStatus: "pending",
    waitingTime: 52,
    ordertime: "2023-02-10T17:52:34Z",
    completetime: "2023-05-10T04:14:46Z",
  },
  {
    name: "Eileen Moreinis",
    email: "emoreinis4@harvard.edu",
    address: "825 Delaware Circle",
    phone: "800-915-5577",
    session: "5023e0ea-7382-4b83-a2e2-c776a942cb4a",
    cart: [
      {
        id: 851,
        name: "Basil - Seedlings Cookstown",
        quantity: 43,
        price: 424.28,
      },
      { id: 122, name: "Iced Tea - Lemon, 340ml", quantity: 70, price: 718.82 },
      { id: 399, name: "Sugar - Brown", quantity: 75, price: 878.61 },
      {
        id: 410,
        name: "Pepper - Paprika, Hungarian",
        quantity: 60,
        price: 150.61,
      },
      { id: 828, name: "Absolut Citron", quantity: 72, price: 997.36 },
      { id: 867, name: "Ham - Proscuitto", quantity: 14, price: 69.61 },
      { id: 74, name: "Olives - Nicoise", quantity: 38, price: 792.28 },
      { id: 873, name: "Juice Peach Nectar", quantity: 88, price: 312.82 },
      { id: 431, name: "Dates", quantity: 75, price: 356.34 },
      { id: 462, name: "Rice - Aborio", quantity: 66, price: 29.48 },
    ],
    totalCost: 522.85,
    orderID: 17035214,
    orderStatus: "pending",
    waitingTime: 63,
    ordertime: "2023-04-11T05:31:03Z",
    completetime: "2023-04-07T03:48:48Z",
  },
  {
    name: "Inesita Bredee",
    email: "ibredee5@sitemeter.com",
    address: "0 Haas Lane",
    phone: "562-710-5953",
    session: "a85d6a06-0e47-4513-b98c-33f1dee7252a",
    cart: [
      { id: 97, name: "Mushrooms - Honey", quantity: 25, price: 969.24 },
      { id: 561, name: "Honey - Liquid", quantity: 64, price: 546.84 },
      { id: 990, name: "Ham - Smoked, Bone - In", quantity: 18, price: 502.71 },
      {
        id: 871,
        name: "Wine - White, Colubia Cresh",
        quantity: 54,
        price: 967.92,
      },
      { id: 711, name: "Kahlua", quantity: 69, price: 105.86 },
      { id: 716, name: "Canadian Emmenthal", quantity: 90, price: 586.42 },
      { id: 323, name: "Sauce Bbq Smokey", quantity: 9, price: 374.16 },
    ],
    totalCost: 55.42,
    orderID: 286499634,
    orderStatus: "completed",
    waitingTime: 100,
    ordertime: "2022-10-30T18:06:45Z",
    completetime: "2023-04-06T14:40:02Z",
  },
  {
    name: "Salli Greenhall",
    email: "sgreenhall6@comcast.net",
    address: "13887 Golf Course Pass",
    phone: "886-248-9845",
    session: "1ec489b5-8eab-4398-bdb1-7fdbea9cb07a",
    cart: [
      { id: 477, name: "Irish Cream - Butterscotch", quantity: 60, price: 0.3 },
      {
        id: 512,
        name: "Soup - Campbells, Beef Barley",
        quantity: 56,
        price: 681.58,
      },
    ],
    totalCost: 782.04,
    orderID: 968917934,
    orderStatus: "pending",
    waitingTime: 92,
    ordertime: "2022-08-18T20:12:53Z",
    completetime: "2022-06-29T10:13:57Z",
  },
  {
    name: "Dori Kernar",
    email: "dkernar7@nsw.gov.au",
    address: "2 Utah Street",
    phone: "206-410-2820",
    session: "e5c523f4-f60d-40dd-9ca9-a6fe5edd6a85",
    cart: [
      { id: 327, name: "Filling - Mince Meat", quantity: 66, price: 635.13 },
      { id: 290, name: "Table Cloth 90x90 Colour", quantity: 19, price: 10.3 },
      {
        id: 441,
        name: "Vinegar - Balsamic, White",
        quantity: 43,
        price: 255.27,
      },
      { id: 71, name: "Stock - Beef, White", quantity: 64, price: 769.16 },
      {
        id: 730,
        name: "Yogurt - Blueberry, 175 Gr",
        quantity: 79,
        price: 77.54,
      },
    ],
    totalCost: 402.91,
    orderID: 333727795,
    orderStatus: "pending",
    waitingTime: 2,
    ordertime: "2023-03-10T01:34:44Z",
    completetime: "2022-12-14T06:21:38Z",
  },
  {
    name: "Blayne Litherland",
    email: "blitherland8@constantcontact.com",
    address: "32 Sauthoff Junction",
    phone: "901-563-7484",
    session: "9d0d1c18-547c-4bf9-9635-e77fe2fd2d79",
    cart: [
      { id: 299, name: "Cactus Pads", quantity: 22, price: 640.71 },
      { id: 146, name: "Fenngreek Seed", quantity: 55, price: 114.19 },
      { id: 703, name: "Tea - Honey Green Tea", quantity: 80, price: 523.09 },
      { id: 948, name: "Turkey - Ground. Lean", quantity: 71, price: 929.99 },
      { id: 466, name: "Otomegusa Dashi Konbu", quantity: 24, price: 781.05 },
      { id: 547, name: "Sauce - Thousand Island", quantity: 91, price: 312.12 },
      { id: 92, name: "Lettuce - Arugula", quantity: 58, price: 587.44 },
      { id: 86, name: "Pepper - Cayenne", quantity: 17, price: 842.13 },
      { id: 401, name: "Cheese - Brie", quantity: 12, price: 592.74 },
    ],
    totalCost: 688.06,
    orderID: 717118230,
    orderStatus: "completed",
    waitingTime: 90,
    ordertime: "2022-08-24T19:01:10Z",
    completetime: "2023-05-08T03:35:02Z",
  },
  {
    name: "Rochette Frere",
    email: "rfrere9@feedburner.com",
    address: "85 Mesta Alley",
    phone: "876-319-5097",
    session: "f7a74794-1c59-40af-9224-3d415a60643a",
    cart: [
      {
        id: 701,
        name: "Rum - Light, Captain Morgan",
        quantity: 64,
        price: 413.82,
      },
      { id: 239, name: "Coffee Caramel Biscotti", quantity: 41, price: 942.66 },
    ],
    totalCost: 955.0,
    orderID: 515198087,
    orderStatus: "completed",
    waitingTime: 44,
    ordertime: "2022-08-09T09:23:52Z",
    completetime: "2022-08-01T03:53:03Z",
  },
  {
    name: "Brook Abramovitz",
    email: "babramovitza@forbes.com",
    address: "19605 8th Circle",
    phone: "388-764-1062",
    session: "2873bc4b-8037-440e-a2e2-bbdb37b68660",
    cart: [
      { id: 756, name: "Ecolab - Solid Fusion", quantity: 2, price: 691.05 },
    ],
    totalCost: 655.38,
    orderID: 450247012,
    orderStatus: "pending",
    waitingTime: 95,
    ordertime: "2022-08-11T22:40:31Z",
    completetime: "2022-12-04T22:15:26Z",
  },
  {
    name: "Raymond McMeyler",
    email: "rmcmeylerb@over-blog.com",
    address: "9976 Loeprich Trail",
    phone: "360-820-6838",
    session: "be60622e-bfd0-41b5-94c5-6d8224b1b3bf",
    cart: [
      {
        id: 45,
        name: "Cheese - Parmigiano Reggiano",
        quantity: 4,
        price: 188.27,
      },
      {
        id: 815,
        name: "Wine - Clavet Saint Emilion",
        quantity: 44,
        price: 905.08,
      },
      {
        id: 611,
        name: "Truffle - Whole Black Peeled",
        quantity: 53,
        price: 905.12,
      },
      { id: 599, name: "Turnip - Mini", quantity: 91, price: 300.64 },
      { id: 825, name: "Veal - Liver", quantity: 79, price: 772.0 },
    ],
    totalCost: 127.4,
    orderID: 460839895,
    orderStatus: "in progress",
    waitingTime: 18,
    ordertime: "2022-12-15T01:06:59Z",
    completetime: "2022-09-05T08:29:20Z",
  },
  {
    name: "Linzy Gonning",
    email: "lgonningc@ocn.ne.jp",
    address: "88 Orin Hill",
    phone: "742-451-4688",
    session: "8af8c5f4-5aca-4160-bbc3-88e9e44ddd12",
    cart: [
      {
        id: 898,
        name: "Wine - Beringer Founders Estate",
        quantity: 85,
        price: 905.62,
      },
      {
        id: 740,
        name: "Wine - Clavet Saint Emilion",
        quantity: 71,
        price: 331.9,
      },
      {
        id: 930,
        name: "Pail With Metal Handle 16l White",
        quantity: 4,
        price: 844.52,
      },
      { id: 415, name: "Bar Mix - Lime", quantity: 58, price: 778.72 },
      { id: 530, name: "Sobe - Orange Carrot", quantity: 11, price: 285.54 },
      { id: 616, name: "Juice - V8 Splash", quantity: 24, price: 736.71 },
      {
        id: 923,
        name: "Beef - Montreal Smoked Brisket",
        quantity: 87,
        price: 566.89,
      },
    ],
    totalCost: 296.61,
    orderID: 991731682,
    orderStatus: "in progress",
    waitingTime: 29,
    ordertime: "2022-06-27T20:42:15Z",
    completetime: "2023-04-06T12:22:07Z",
  },
  {
    name: "Saloma Wilbraham",
    email: "swilbrahamd@netvibes.com",
    address: "0 Bowman Alley",
    phone: "348-691-3345",
    session: "52941f90-76f6-4912-946e-03044fee2aa1",
    cart: [
      { id: 286, name: "Beef - Shank", quantity: 99, price: 217.53 },
      { id: 636, name: "Squid - U - 10 Thailand", quantity: 97, price: 185.85 },
      {
        id: 898,
        name: "Cheese - Le Cru Du Clocher",
        quantity: 65,
        price: 877.77,
      },
      { id: 449, name: "Oil - Macadamia", quantity: 20, price: 292.47 },
      {
        id: 100,
        name: "Cake - Mini Potato Pancake",
        quantity: 34,
        price: 250.05,
      },
      { id: 66, name: "Cheese - Gouda Smoked", quantity: 94, price: 163.07 },
      { id: 491, name: "Coriander - Ground", quantity: 87, price: 144.63 },
      { id: 818, name: "Chervil - Fresh", quantity: 64, price: 498.52 },
    ],
    totalCost: 866.82,
    orderID: 969109318,
    orderStatus: "completed",
    waitingTime: 15,
    ordertime: "2023-02-04T13:39:21Z",
    completetime: "2022-09-02T04:04:15Z",
  },
  {
    name: "Burnard McOwan",
    email: "bmcowane@uol.com.br",
    address: "01803 Cambridge Alley",
    phone: "910-229-5219",
    session: "e826df2a-9f24-40af-9acd-ac77fbd833bb",
    cart: [
      { id: 723, name: "Lettuce - Spring Mix", quantity: 75, price: 145.49 },
      { id: 809, name: "Salmon - Fillets", quantity: 75, price: 188.34 },
      { id: 103, name: "Flour - Pastry", quantity: 73, price: 919.21 },
      { id: 442, name: "Appetizer - Cheese Bites", quantity: 7, price: 630.88 },
      { id: 655, name: "Cheese - Mix", quantity: 19, price: 666.51 },
      {
        id: 702,
        name: "Containter - 3oz Microwave Rect.",
        quantity: 97,
        price: 112.02,
      },
      { id: 361, name: "Cake - French Pear Tart", quantity: 36, price: 312.04 },
    ],
    totalCost: 135.07,
    orderID: 478557309,
    orderStatus: "in progress",
    waitingTime: 82,
    ordertime: "2022-10-04T13:01:58Z",
    completetime: "2022-07-04T10:34:01Z",
  },
  {
    name: "Trace Kember",
    email: "tkemberf@unblog.fr",
    address: "72 Nancy Park",
    phone: "153-680-6046",
    session: "5b9c4f59-ebb3-4817-810e-5926a56a3881",
    cart: [
      { id: 814, name: "Clementine", quantity: 46, price: 357.13 },
      { id: 326, name: "Chocolate - Milk", quantity: 40, price: 117.13 },
      { id: 159, name: "Artichoke - Fresh", quantity: 3, price: 203.37 },
      { id: 22, name: "Cookies - Assorted", quantity: 40, price: 362.04 },
    ],
    totalCost: 882.27,
    orderID: 990772043,
    orderStatus: "in progress",
    waitingTime: 43,
    ordertime: "2023-01-21T19:03:33Z",
    completetime: "2023-04-12T03:44:24Z",
  },
  {
    name: "Gratia Angear",
    email: "gangearg@hao123.com",
    address: "6 Namekagon Plaza",
    phone: "549-366-7431",
    session: "8c7ad8e3-73e5-4a9d-97c2-b910e729aa7a",
    cart: [
      { id: 737, name: "Lamb - Rack", quantity: 25, price: 38.94 },
      { id: 8, name: "Pheasants - Whole", quantity: 89, price: 682.85 },
      { id: 205, name: "Oil - Olive Bertolli", quantity: 41, price: 317.73 },
    ],
    totalCost: 191.24,
    orderID: 12247857,
    orderStatus: "in progress",
    waitingTime: 94,
    ordertime: "2022-08-18T22:39:27Z",
    completetime: "2022-11-05T22:38:51Z",
  },
  {
    name: "Karon Sweetenham",
    email: "ksweetenhamh@ovh.net",
    address: "595 Mesta Road",
    phone: "235-539-7283",
    session: "5fb61ef1-c841-4fb0-a291-1c068b9f98eb",
    cart: [
      { id: 700, name: "Cup - 4oz Translucent", quantity: 91, price: 135.49 },
      { id: 973, name: "Radish - Pickled", quantity: 78, price: 436.37 },
    ],
    totalCost: 790.63,
    orderID: 158190771,
    orderStatus: "pending",
    waitingTime: 77,
    ordertime: "2023-04-26T09:09:30Z",
    completetime: "2022-10-27T05:58:56Z",
  },
  {
    name: "Free Neil",
    email: "fneili@businesswire.com",
    address: "71457 Westerfield Hill",
    phone: "704-976-6306",
    session: "c69fd78e-a735-495a-bf87-e5a9a6cab887",
    cart: [
      { id: 802, name: "Seedlings - Clamshell", quantity: 35, price: 874.72 },
      { id: 382, name: "Ostrich - Fan Fillet", quantity: 14, price: 922.45 },
      {
        id: 19,
        name: "Napkin - Cocktail,beige 2 - Ply",
        quantity: 31,
        price: 162.96,
      },
    ],
    totalCost: 601.31,
    orderID: 87904503,
    orderStatus: "completed",
    waitingTime: 88,
    ordertime: "2022-07-26T03:51:43Z",
    completetime: "2022-10-13T15:39:25Z",
  },
  {
    name: "Buckie Fazackerley",
    email: "bfazackerleyj@delicious.com",
    address: "5881 Glendale Trail",
    phone: "783-380-0185",
    session: "11b7f36b-4b1d-40ea-a370-087e9f5e9fb1",
    cart: [
      {
        id: 865,
        name: "Bread - Roll, Whole Wheat",
        quantity: 66,
        price: 766.07,
      },
      {
        id: 880,
        name: "Chinese Foods - Pepper Beef",
        quantity: 49,
        price: 820.78,
      },
      {
        id: 862,
        name: "Bar Mix - Pina Colada, 355 Ml",
        quantity: 39,
        price: 810.97,
      },
      { id: 174, name: "Cheese - Cream Cheese", quantity: 95, price: 701.55 },
      { id: 627, name: "Cleaner - Bleach", quantity: 49, price: 688.23 },
      { id: 926, name: "Island Oasis - Lemonade", quantity: 14, price: 142.74 },
      { id: 109, name: "Pepper Squash", quantity: 90, price: 199.49 },
      { id: 47, name: "V8 - Vegetable Cocktail", quantity: 73, price: 145.6 },
    ],
    totalCost: 608.52,
    orderID: 259208298,
    orderStatus: "in progress",
    waitingTime: 66,
    ordertime: "2023-03-11T07:26:36Z",
    completetime: "2022-06-10T03:29:21Z",
  },
];
